import { atom } from 'jotai';

export const loginAtom = atom(false);
